﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";

export function initConfirmationModal(){
    $(document).on('click', 'a[confirmation-modal]', function () {
        let self = $(this);
        createConfirmationModal(self, function () {
            window.location.href = self.attr('href');
        });
        return false;
    });

    $(document).on('click', 'button[confirmation-modal]', function () {
        let self = $(this);
        createConfirmationModal(self, function () {
            self.closest('form').submit();
        });
        return false;
    });
}

function createConfirmationModal(element, confirmCallback, cancelCallback = function () {}) {
    $("body").append(`
        <div class="modal fade" id="confirmationModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="confirmationModalLabel">${element.data('confirmation-title') ?? "Confirmation"}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                    ${element.data('confirmation-message') ?? "Are you sure want to continue?"}
              </div>
              <div class="modal-footer">
                <button type="button" cancel-button class="btn btn-secondary">${element.data('confirmation-cancel') ?? "Cancel"}</button>
                <button type="button" confirm-button class="btn btn-primary">${element.data('confirmation-confirm') ?? "Confirm"}</button>
              </div>
            </div>
          </div>
        </div>`);
    let modal = $('#confirmationModal');
    modal.modal('show');
    modal.on('click', '[cancel-button]', function () {
        modal.modal('hide');
        modal.remove();
        cancelCallback();
    });
    modal.on('click', '[confirm-button]', function () {
        modal.modal('hide');
        modal.remove();
        confirmCallback();
    });
}